import { useEffect, useCallback } from 'react';
export const SKIP_OUTSIDE_CLICK_CLASS = 'skip-outside-click';
const useClickOutside = (ref, onClick) => {
    const hasClass = (element, classname) => {
        return !!element?.className && element.className.split(' ').indexOf(classname) >= 0;
    };
    const handleClickOutside = useCallback((event) => {
        if (ref?.current &&
            !ref?.current.contains(event.target) &&
            !hasClass(event.target, SKIP_OUTSIDE_CLICK_CLASS)) {
            onClick(event);
        }
    }, [ref, onClick]);
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClickOutside]);
};
export { useClickOutside };
//# sourceMappingURL=useClickOutside.js.map